import React from 'react';
import { Box, Heading, Text, VStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const HEADING_SIZES = {
  md: { base: '1.65rem', md: '1.9rem', lg: '2rem' },
  lg: { base: '1.85rem', md: '2.25rem' },
};

const SectionHeading = ({ title, subtitle, align = 'left', mb = 14, size = 'md', ...rest }) => {
  return (
    <VStack
      spacing={3}
      mb={mb}
      align={align === 'left' ? 'flex-start' : 'center'}
      textAlign={align}
      width="full"
      {...rest}
    >
      <Heading
        as="h2"
        fontFamily="heading"
        fontWeight={500}
        fontSize={HEADING_SIZES[size] || HEADING_SIZES.md}
        lineHeight={1.08}
        letterSpacing="0"
        color="#F5F7FA"
      >
        {title}
      </Heading>
      <MotionBox
        h="2px"
        w="44px"
        bg="linear-gradient(90deg, #D4A85F 0%, #E0B873 100%)"
        borderRadius="full"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
        transformOrigin={align === 'center' ? '50% 50%' : '0% 50%'}
      />
      {subtitle && (
        <Text
          fontFamily="body"
          fontSize={{ base: 'md', md: 'md' }}
          color="#9AA7B8"
          maxW={{ base: 'full', md: '640px' }}
          lineHeight={1.6}
        >
          {subtitle}
        </Text>
      )}
    </VStack>
  );
};

export default SectionHeading;
